export const PuntosActionTypes = {
  API_RESPONSE_SUCCESS: '@@puntos-interes/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@puntos-interes/API_RESPONSE_ERROR',

  GET_PUNTO: '@@puntos-interes/GET_PUNTO',
  LIST_PUNTOS: '@@puntos-interes/LIST_PUNTOS',
  ADD_PUNTO: '@@puntos-interes/ADD_PUNTO',
  UPDATE_PUNTO: '@@puntos-interes/UPDATE_PUNTO',
  DELETE_PUNTO: '@@puntos-interes/DELETE_PUNTO',
  SET_FILTER: '@@puntos-interes/SET_FILTER',

  RESET: '@@puntos-interes/RESET'
}
